﻿import shelf from './shelf';
import dropdown from './dropdown';
import './clipboard';
import './payment';
import './tabs';
import './videos';

declare var hljs: any;

shelf();
dropdown();